// Taşeron portalı — Mobil Uygulama sayfası (panel-İÇİ; api-contract §26). Yetkili (panel erişimi
// olan) principal için: portal kabuğunun içinde, NAV'daki "Mobil Uygulama" girişinden açılır.
// iOS/Android mağaza linklerini (`GET /app-settings`) gösterir; link boşsa "yakında".
//
// Panel yetkisi OLMAYAN (Personeli) principal buraya GELMEZ — onun için tüm kabuk yerine tam-ekran
// `AppDownloadOnly` gösterilir (`SupplierShellGate`, D3). Bu sayfa panel-gate DIŞIdır (herhangi
// authenticated okur, §26.1) ama pratikte yalnız kabuğu gören (Yetkili) principal'a görünür.

import { Breadcrumb, Card, CardContent, PageHeader, Spinner } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { AppDownloadLinks } from '../components/AppDownloadLinks';
import { useAppSettings } from '../lib/useAppSettings';

export function MobileAppPage() {
  const { t } = useTranslation();
  const { iosAppUrl, androidAppUrl, isLoading } = useAppSettings();

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={[{ label: t('mobileApp.title') }]} />
      <PageHeader title={t('mobileApp.title')} helperText={t('mobileApp.subtitle')} />

      <Card>
        <CardContent className="flex flex-col gap-4">
          <h2 className="text-sm font-semibold text-fg">{t('appDownload.storesTitle')}</h2>
          {isLoading ? (
            <div className="flex min-h-[6rem] items-center justify-center">
              <Spinner label={t('appDownload.loading')} />
            </div>
          ) : (
            <AppDownloadLinks iosAppUrl={iosAppUrl} androidAppUrl={androidAppUrl} size="lg" />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
